import type { OfferSiteBundle } from "./offerSite";

const stack = [
  "Kubernetes, Helm, Rancher, Docker",
  "AWS (EKS, RDS, S3, Shield), Hetzner bare-metal",
  "Terraform, Ansible, GitLab CI",
  "Prometheus, Grafana, Loki, ELK",
  "Cloudflare WAF/DDoS, Vault, PCI DSS",
  "PostgreSQL, MongoDB, Ceph, RabbitMQ",
  "Ollama / vLLM, RAG (ChromaDB) — so‘rov bo‘yicha",
];

const proof = [
  { brand: "Raiffeisen Bank", note: "AWS, PCI, audit CI/CD" },
  { brand: "Crypto exchange", note: "EKS, WAF, nodelar, vaults" },
  { brand: "Epicenter / 27.ua", note: "Highload, Ceph, klaster" },
  { brand: "DDoS", note: "100 Gbps / keys ~10M pps" },
];

/** O‘zbekcha (lotin): IT-terminlar xalqaro, matn — odam yozgandek. */
export const uz: OfferSiteBundle = {
  seoHome: {
    title: "Ayirboshlash, to‘lov va highload infratuzilmasi | IT-24.pro",
    description:
      "Infratuzilma muhandisi: DDoS, PCI DSS, Kubernetes, nodelar, vaults. Bank va birja tajribasi. Telegram, USDT/invoys. Retainer $1 500/oydan.",
  },
  ui: { open: "Ochish", forWhom: "Kimlar uchun", includes: "Nima kiradi" },
  nav: {
    services: "Xizmatlar",
    cases: "Keyslar",
    about: "Men haqimda",
    contacts: "Aloqa",
    telegramCta: "Telegramga yozish",
  },
  hero: {
    eyebrow: "IT-24.pro · ayirboshlash · to‘lov · highload",
    h1: "To‘xtasa — pul ketadigan infratuzilma",
    lead:
      "Birja, to‘lov va yuqori yuklamali servislar productionini quraman va ushlab turaman: DDoS, PCI DSS, Kubernetes, maxfiy kalitlar va nodelar. O‘zim ishlayman — Telegramda javob beraman.",
    ctaTg: "Telegramga yozish",
    ctaOffers: "Xizmatlar va narx",
    chips: ["PCI DSS L1/L2", "DDoS 100+ Gbps", "USDT / PL invoys", "2010-yildan infratuzilmada"],
  },
  proofTitle: "Ismlar bo‘yicha tajriba",
  proofLead: "Rezyume va keyslardan tekshirish mumkin — «500+ loyiha» yo‘q.",
  proof,
  offersTitle: "Xizmatlar",
  offersLead: "To‘rt format. VPS va «$80 ga admin» tariflari yo‘q.",
  offers: [
    {
      id: "incident",
      href: "/services/incident",
      title: "Shoshilinch yordam",
      price: "$100–150/soat · paket $600 dan",
      blurb: "Nosozlik, DDoS yoki kirish yo‘qolganda productionni ko‘taraman.",
      bullets: ["Telegramda reaksiya", "Insidentdan keyin tahlil", "Obuna shartisiz"],
    },
    {
      id: "audit",
      href: "/services/audit",
      title: "Audit 1–2 kun",
      price: "$300–600",
      blurb: "Infratuzilma xavfi, PCI DSS ga tayyorgarlik va hujumga chidamlilik.",
      bullets: ["Yozma hisobot", "Nimadan boshlash", "30–60 daqiqa qo‘ng‘iroq"],
    },
    {
      id: "retainer",
      href: "/services/retainer",
      title: "Retainer — infratuzilmani kuzatish",
      price: "$1 500–2 500/oy",
      blurb: "Ayirboshlash va fintech uchun tashqi DevOps: reliz, monitoring, insident.",
      bullets: ["40–80 soat ekvivalenti", "Telegram-kanal", "Tiklash tekshirilgan backup"],
    },
    {
      id: "projects",
      href: "/services/projects",
      title: "Kalitga loyiha",
      price: "$3 000–8 000 fixed",
      blurb: "PCI DSS konturi, DDoS himoyasi, migratsiya, Kubernetes va CI/CD, nodelar va maxfiy ombor.",
      bullets: ["2–4 hafta", "Qat’iy narx", "Topshirish hujjatlari"],
    },
  ],
  payTitle: "Qanday to‘lashadi",
  payItems: ["USDT (TRC-20)", "UZS", "Wise / Payoneer", "Polsha invoysi (VAT)"],
  payNote: "Polshadagi yuridik shaxs — Yevropa mijozlari va USDT hisob-kitobiga qulay.",
  howTitle: "Qanday boshlaymiz",
  howSteps: [
    { t: "Telegramga xabar", p: "Qisqa: nima yonayapti, stek, byudjet." },
    { t: "30 daqiqalik qo‘ng‘iroq", p: "Insident, audit, retainer yoki bir martalik loyiha." },
    { t: "Audit yoki pilot", p: "Kichik kirish — yillik shartisiz." },
    { t: "Retainer yoki fixed", p: "Keyin — kuzatuv yoki tushunarli natijali loyiha." },
  ],
  aboutTeaser: {
    title: "Igor Kositsyn",
    text: "DevOps / MLOps, Konin (PL). Linux highload 2010-yillardan, cloud-native so‘nggi yillar. Yuridik shaxs Polshada.",
    link: "Batafsil",
  },
  footerTagline:
    "Ayirboshlash, fintech va yuqori yuklamali tizimlar infratuzilmasi. MDH bozori · PL yuridik shaxs · Telegram.",
  footerEuNote: "EU bozori uchun — alohida sayt",
  footerEuLink: "nexops.eu",
  casesPage: {
    seo: {
      title: "Keyslar: bank, birja, DDoS, highload | IT-24.pro",
      description: "Misollar: PCI DSS, birja infratuzilmasi, hujumdan himoya, e-commerce highload.",
    },
    h1: "Keyslar",
    lead: "Vazifa, nima qildim, nima bilan tugadi.",
    labels: { problem: "Vazifa", did: "Yechim", result: "Natija" },
    items: [
      {
        title: "Kriptobirja: production va komplayens",
        problem: "Qo‘lda relizsiz ayirboshlash va noda infratuzilmasi, maxfiy kalitlarni nazorat qilish kerak edi.",
        did: "AWS EKS va bare-metal Kubernetes, Helm, GitLab CI, WAF, Ceph, nodelar, vaults, Ansible va Terraform.",
        result: "Qo‘lda ovora relizlar yo‘q, auditga tayyor kontur, productionda kuzatuv.",
      },
      {
        title: "Raiffeisen: migratsiya va PCI DSS",
        problem: "Infratuzilmani ko‘chirish va moliya sektorining audit hamda kirish talablari.",
        did: "AWS ga migratsiya, Kubernetes, CI/CD hardening, PCI DSS Level 1/2 tayyorgarligida infratuzilma tomondan ishtirok.",
        result: "Tekshiruvga tayyorlik va takrorlanadigan deploylar.",
      },
      {
        title: "Reklama ishga tushganda DDoS",
        problem: "Sekundiga ~10 mln paketgacha cho‘qqi; data-markazlar hujumni filtrlashmadi.",
        did: "L3–L7 filtr, muhim servislarni himoyalangan konturga ko‘chirish, monitoring, zaxira marshrutlar.",
        result: "Hujumning bir oyida auditoriyaning taxminan 80% i kirishni saqlab qoldi.",
      },
      {
        title: "E-commerce / riteyl, highload",
        problem: "Yuklama cho‘qqilari, yuzlab terabayt ombor, turli mintaqalardan kirish.",
        did: "Nginx, MySQL, Ceph, klasterlar, kesh, Ukraina — Fransiya sxemasi.",
        result: "Yuklama ostida barqaror ish va ma’lumotlarni himoyalangan saqlash.",
      },
    ],
  },
  aboutPage: {
    seo: {
      title: "Men haqimda — Igor Kositsyn, DevOps/MLOps | IT-24.pro",
      description: "Ayirboshlash va fintech infratuzilmasi muhandisi. Polsha, bank va birja, PCI DSS, DDoS, Kubernetes.",
    },
    h1: "Men haqimda",
    lead: "Igor Kositsyn. DevOps / MLOps: infratuzilmani o‘zim loyihalayman va kuzataman, saytda «yigirma kishilik jamoa» yo‘q.",
    body: [
      "Yuridik shaxs Polshada (Konin). Avval Ukrainada infratuzilma qurganman: bank, riteyl, birjalar.",
      "To‘xtash yoki buzilish pul va tekshiruvga uradigan vazifalarni olaman: to‘lov, ayirboshlash, cho‘qqi yuklama, PCI DSS ga tayyorgarlik.",
      "Yevropa mijozlarini nexops.eu da olib boraman. IT-24.pro — MDH buyurtmachilariga.",
    ],
    stackTitle: "Stek",
    stack,
  },
  contactsPage: {
    seo: {
      title: "Aloqa — Telegram, USDT to‘lov | IT-24.pro",
      description: "Telegram @devops_it24. USDT, UZS, Polsha invoysi.",
    },
    h1: "Aloqa",
    lead: "Asosiy kanal — Telegram. O‘zim javob beraman, tiket navbati yo‘q.",
    tgHint: "Qisqa: stek va hozir nima og‘riyapti.",
    payTitle: "To‘lov",
    payItems: ["USDT TRC-20", "UZS", "Wise / Payoneer", "PL invoys (VAT)"],
    payNote: "Polshadagi yuridik shaxs — Yevropa mijozlari va USDT uchun qulay.",
  },
  services: {
    incident: {
      id: "incident",
      path: "/services/incident",
      seo: {
        title: "Infratuzilma bo‘yicha shoshilinch yordam — insident va DDoS | IT-24.pro",
        description:
          "Hujum, komprometatsiya yoki servis yiqilgandan keyin productionni tiklash. $100–150/soat yoki $600 dan paket. Telegram.",
      },
      breadcrumb: "Shoshilinch yordam",
      h1: "Shoshilinch yordam",
      lead: "Production yotgan bo‘lsa — avval kirishni ko‘taraman, keyin sababini qarab chiqaman. Insident o‘rtasida «Growth paketi» tanlatmayman.",
      price: "$100–150/soat · insident paketi $600 dan",
      forWhom: [
        "Ayirboshlash, to‘lov va reklama byudjeti bor servislar",
        "O‘z DevOps on-call yo‘q",
        "Hujum, komprometatsiya, kirish yo‘qolishi, ma’lumotga xavf",
      ],
      includes: [
        "Diagnostika va kirishni tiklash",
        "Dastlabki hardening (kirish, firewall, ochiq teshiklar)",
        "Qisqa post-mortem: nima bo‘ldi va keyin nima tuzatish",
        "Kelishuvga ko‘ra — audit yoki retainer ga o‘tish",
      ],
      cta: "Insident haqida Telegramga yozish",
    },
    audit: {
      id: "audit",
      path: "/services/audit",
      seo: {
        title: "Infratuzilma auditi va PCI DSS tayyorgarligi | IT-24.pro",
        description: "1–2 kunlik audit: xavfsizlik, DDoS konturi, bulut hisobi, PCI DSS. $300–600.",
      },
      breadcrumb: "Audit",
      h1: "Audit 1–2 kun",
      lead: "Xavflar aniqligi uchun to‘laysiz — yillik shartisiz.",
      price: "$300–600 fixed",
      forWhom: [
        "PCI DSS yoki tashqi auditga tayyorgarlik",
        "Bulut provayderidagi hisob o‘sib bormoqda",
        "Kontur hujum yoki cho‘qqiga qanday chidaydi — tushunarsiz",
      ],
      includes: [
        "Arxitektura, kirish, backup, monitoring ko‘rigi",
        "Ustuvorlik bo‘yicha xavflar ro‘yxati",
        "Bartaraf etish byudjeti bahosi (retainer yoki loyiha)",
        "Hisobot bo‘yicha qo‘ng‘iroq",
      ],
      cta: "Telegramda auditga buyurtma",
    },
    retainer: {
      id: "retainer",
      path: "/services/retainer",
      seo: {
        title: "Ayirboshlash va fintech uchun DevOps retainer | IT-24.pro",
        description: "Oylik kuzatuv $1 500–2 500: reliz, monitoring, insident, backup.",
      },
      breadcrumb: "Retainer",
      h1: "Retainer — infratuzilmani kuzatish",
      lead: "$100 hosting bilan emas, ta’tili va bus factor i bor Middle/Senior DevOps $2.7–5k/oy bilan solishtiring.",
      price: "$1 500–2 500 / oy",
      forWhom: [
        "Ayirboshlash, to‘lov, fintech yoki highload-mahsulot",
        "Mijoz loyihalarida o‘z DevOps i yo‘q studiya",
        "Tiket xizmati emas, Telegramdagi mas’ul odam kerak",
      ],
      includes: [
        "Kelishilgan oynada monitoring va insidentga reaksiya",
        "Soat limiti ichida reliz, CI/CD va infratuzilma tuzatishlari",
        "Yangilash, backup, tiklashni vaqti-vaqti bilan tekshirish",
        "Oyiga qisqa hisobot: qilingani va xavf zonalar",
      ],
      cta: "Telegramda retainer muhokama",
    },
    projects: {
      id: "projects",
      path: "/services/projects",
      seo: {
        title: "PCI DSS, DDoS, Kubernetes — kalitga loyihalar | IT-24.pro",
        description:
          "Qat’iy narx $3–8k: PCI DSS konturi, DDoS himoyasi, migratsiya, Kubernetes va CI/CD, nodelar va vaults.",
      },
      breadcrumb: "Loyihalar",
      h1: "Kalitga loyiha",
      lead: "Oylik «soat» emas, 2–4 haftada tushunarli natija kerak bo‘lganda.",
      price: "$3 000–8 000 fixed · 2–4 hafta",
      forWhom: [
        "Infratuzilmani PCI DSS ga tayyorlash",
        "Insidentdan keyin yoki ishga tushirish oldidan DDoS / WAF konturi",
        "Migratsiya (bulut ↔ bare-metal), noldan Kubernetes, nodelar va vaults",
      ],
      includes: [
        "Boshlashdan oldin skop va qat’iy narx",
        "IaC, hujjatlar, kirishni topshirish",
        "Qabul mezonlari (kirish, pipeline, backupdan tiklash)",
        "Variant: ishga tushgandan keyin kuzatuv (retainer)",
      ],
      cta: "Loyihani Telegramda tasvirlash",
    },
  },
};
